export const setTokens = (accessToken, refreshToken, tokenExpiration, refreshTokenExpiration) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  if (tokenExpiration != null) {
    localStorage.setItem("tokenExpiration", String(tokenExpiration));
  }
  if (refreshTokenExpiration != null) {
    localStorage.setItem("refreshTokenExpiration", String(refreshTokenExpiration));
  }
};

export const getAccessToken = () => localStorage.getItem("accessToken");
export const getRefreshToken = () => localStorage.getItem("refreshToken");
export const getTokenExpiration = () => localStorage.getItem("tokenExpiration");
export const getRefreshTokenExpiration = () => localStorage.getItem("refreshTokenExpiration");

export const clearTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("tokenExpiration");
  localStorage.removeItem("refreshTokenExpiration");
};

/** Clear tokens and typical session keys after auth failure. */
export const clearSessionAuth = () => {
  clearTokens();
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("userName");
  localStorage.removeItem("userId");
  localStorage.removeItem("clientId");
  localStorage.removeItem("userRole");
  localStorage.removeItem("isMasterUser");
};